import type { FC } from 'react';
import React, { useEffect } from 'react';
const AuthTransition: FC = () => {
  useEffect(() => {
    // Disable scrolling when the component mounts
    document.body.style.overflow = 'hidden';

    // Cleanup to re-enable scrolling when the component unmounts
    return () => {
      document.body.style.overflow = '';
    };
  }, []);
  return <div className="fixed left-0 top-0 z-[200] flex h-screen w-screen flex-col items-center justify-center bg-white" data-sentry-component="AuthTransition" data-sentry-source-file="AuthTransition.tsx">
      <div className="-mt-20 rounded-full border-r-[1px] border-r-blueFour p-8" style={{
      animation: 'spin 2s linear infinite'
    }} />
      <div className="-mt-10 rounded-full border-l-[1px] border-l-orangeFour p-8" style={{
      animation: 'spin 2s linear infinite'
    }} />
      <p className="mt-6 text-lg drop-shadow-lightBlue">
        در حال انتقال به صفحه‌ی موردنظر
        <span className="text-2xl"> ...</span>
      </p>
      <style jsx>{`
        @keyframes spin {
          from {
            transform: rotate(360deg);
          }
          to {
            transform: rotate(0deg); /* Clockwise rotation */
          }
        }
      `}</style>
    </div>;
};
export default AuthTransition;